import { apiClient } from '@/config/api';
import {
    SidebarWithDetails,
    UpdateSidebarDto,
    SidebarApiResponse
} from '@/types/sidebar';

class SidebarService {
    // Lấy sidebar với thông tin chi tiết
    async getSidebar(): Promise<SidebarWithDetails> {
        const response = await apiClient.get<SidebarApiResponse>('/sidebar');

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy sidebar');
        }

        if (!response.data?.data) {
            throw new Error('Không có dữ liệu sidebar');
        }

        return response.data.data;
    }

    // Cập nhật sidebar
    async updateSidebar(updateSidebarDto: UpdateSidebarDto): Promise<SidebarWithDetails> {
        const response = await apiClient.put<SidebarApiResponse>('/sidebar', updateSidebarDto);

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi cập nhật sidebar');
        }

        if (!response.data?.data) {
            throw new Error('Không có dữ liệu sidebar sau khi cập nhật');
        }

        return response.data.data;
    }
}

export const sidebarService = new SidebarService();
